// Replace with your actual contact API endpoint
export const CONTACT_API_URL = "https://api.neuzenai.com/api/contact";
